module.exports = __webpack_public_path__ + "img/waist.de7c9996.png";